import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-sas-clinic-reset-password',
  templateUrl: './sas-clinic-reset-password.component.html',
  styleUrls: [
    './sas-clinic-reset-password.component.css',
    '../style/global.css',
  ],
})
export class SasClinicResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit {
  errorMessageDict = {
    passwordNotInput: 'パスワードを入力してください。',
    confirmPasswordNotInput: '確認用パスワードを入力してください。',
    passwordNotMatch: 'パスワードが一致しません。',
  };

  inputState = {
    password: { isFocus: false, isShow: false },
    confirmPassword: { isFocus: false, isShow: false },
  };

  constructor(title: Title) {
    super();
    title.setTitle('新しいパスワードを設定');
  }
  ngOnInit(): void { }

  async submitChangePassword() {
    this.errorMessages = {
      password: '',
      confirmPassword: '',
    };

    // 親コンポーネントの処理をコピー. TODOこの処理を共通化する
    if (!this.password) {
      this.errorMessages.password = this.errorMessageDict.passwordNotInput;
    }
    if (!this.confirmationPassword) {
      this.errorMessages.confirmPassword =
        this.errorMessageDict.confirmPasswordNotInput;
    } else if (this.password !== this.confirmationPassword) {
      this.errorMessages.confirmPassword =
        this.errorMessageDict.passwordNotMatch;
    }
    if (this.errorMessages.password || this.errorMessages.confirmPassword) {
      return;
    }

    const isValidPassword = DxauthService.passwordValidator(this.password, {
      minLength: 10,
      isCharaUnique: false,
    });
    if (isValidPassword.isValid === false) {
      this.errorMessages.password = isValidPassword.errorMessage;
      return;
    }
    super.submitChangePassword();
  }
}
